export interface UserDetailsDraft {
  firstName: string;
  lastName: string;
  email: string;
  password: string;
  confirmPassword: string;
}

export type UserDetailsFieldErrors = Partial<Record<'firstName' | 'lastName' | 'email' | 'password' | 'confirmPassword', string>>;

const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

/** Pure, unit-tested field validation for the User Details tab — mirrors ui/src/features/workers/workersValidation.ts. */
export const validateUserDetails = (draft: UserDetailsDraft, options: { requirePassword: boolean }): UserDetailsFieldErrors => {
  const errors: UserDetailsFieldErrors = {};
  if (!draft.firstName.trim()) errors.firstName = 'First name is required.';
  if (!draft.lastName.trim()) errors.lastName = 'Last name is required.';
  if (!draft.email.trim()) errors.email = 'Email is required.';
  else if (!EMAIL_PATTERN.test(draft.email.trim())) errors.email = 'Enter a valid email address.';
  if (options.requirePassword && !draft.password.trim()) errors.password = 'Password is required.';
  if (options.requirePassword && !draft.confirmPassword.trim()) errors.confirmPassword = 'Confirm password is required.';
  else if (options.requirePassword && draft.password !== draft.confirmPassword) errors.confirmPassword = 'Passwords do not match.';
  return errors;
};

export const hasErrors = (errors: Record<string, string | undefined>): boolean => Object.values(errors).some(Boolean);
